/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S14_P2Inputs */

const tr_mesafeli_s14_p2 = /** @type {(inputs: Mesafeli_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, üçüncü taraf hizmetlerin (pazaryerleri, QNB, Sipay, kargo sağlayıcıları vb.) hizmet kesintilerinden, gecikmelerinden veya işlem hatalarından sorumlu değildir.`)
};

const en_mesafeli_s14_p2 = /** @type {(inputs: Mesafeli_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider is not liable for service interruptions, delays or processing errors of third-party services (marketplaces, QNB, Sipay, shipping providers, etc.).`)
};

const de_mesafeli_s14_p2 = /** @type {(inputs: Mesafeli_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter haftet nicht für Betriebsunterbrechungen, Verzögerungen oder Verarbeitungsfehler von Diensten Dritter (Marktplätze, QNB, Sipay, Versanddienstleister usw.).`)
};

const ru_mesafeli_s14_p2 = /** @type {(inputs: Mesafeli_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик не несёт ответственности за перебои в работе, задержки или ошибки обработки со стороны услуг третьих лиц (маркетплейсы, QNB, Sipay, службы доставки и т. п.).`)
};

/**
* | output |
* | --- |
* | "The Provider is not liable for service interruptions, delays or processing errors of third-party services (marketplaces, QNB, Sipay, shipping providers, etc.)." |
*
* @param {Mesafeli_S14_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s14_p2 = /** @type {((inputs?: Mesafeli_S14_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S14_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s14_p2(inputs)
	if (locale === "de") return de_mesafeli_s14_p2(inputs)
	if (locale === "ru") return ru_mesafeli_s14_p2(inputs)
	return tr_mesafeli_s14_p2(inputs)
});